import { useRef } from 'react';

import { useDragNDropSort } from '@app/hooks/useDragNDropSort';
import { getFieldOnMainLanguage } from '@app/utils/languages';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { TreeLeaf } from './TreeLeaf';
import { TreeNode } from './TreeNode';

interface TreeItemProps {
  index: number;
  orderable?: boolean;
  taxonomy: GenericObject;
  toggleItem?(): void;
  moveCard?(dragIndex: number, hoverIndex: number): void;
  handleShowInfo?(item: GenericObject | null): void;
  isOpen?: boolean;
  selectedTaxonomy: GenericObject | null;
}

const MAX_TAXONOMY_LEVEL = 4;

export const TreeItem = ({
  index,
  orderable,
  taxonomy,
  toggleItem,
  moveCard,
  handleShowInfo,
  isOpen,
  selectedTaxonomy,
}: TreeItemProps) => {
  const ref = useRef(null);
  const { handlerId, drop, isDragging, drag } = useDragNDropSort({
    ref,
    index,
    id: taxonomy?.id,
    moveCard,
    direction: 'row',
  });

  //If the item is dragging, the opacity property on CSS will be 0
  const opacity = isDragging ? 0 : 1;

  drag(drop(ref));

  return (
    <div
      ref={orderable ? ref : null}
      data-handler-id={handlerId}
      data-cy={`taxonomy-item-${getFieldOnMainLanguage(taxonomy?.category_name)}`}
      style={{ cursor: orderable ? 'move' : 'auto', opacity }}
      className={!orderable ? `container ${taxonomy?.id === selectedTaxonomy?.id ? 'selected' : ''}` : ''}>
      {taxonomy.level !== MAX_TAXONOMY_LEVEL ? (
        <TreeNode
          orderable={orderable}
          handleToggle={toggleItem}
          handleClickItem={handleShowInfo}
          taxonomy={taxonomy}
          isOpen={isOpen}
        />
      ) : (
        <TreeLeaf orderable={orderable} handleClick={handleShowInfo} taxonomy={taxonomy} />
      )}
    </div>
  );
};
